import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'activate.account.email.page.title': {
    id: 'activate.account.email.page.title',
    defaultMessage: 'Activate your account',
    description: 'activate account email page title',
  },
  'activate.account.email.label': {
    id: 'activate.account.email.label',
    defaultMessage: 'Email',
    description: 'Label for email field',
  },
  'activate.account.identity.label': {
    id: 'activate.account.identity.label',
    defaultMessage: '{label}',
    description: 'Label for account identity input',
  },
  'activate.account.empty.email.field.error': {
    id: 'aactivate.account.empty.email.field.error',
    defaultMessage: 'Enter your email',
    description: 'Error message that appears when user tries to submit empty email field',
  },
  'activate.account.empty.identity.field.error': {
    id: 'activate.account.empty.identity.field.error',
    defaultMessage: 'Enter your username or email',
    description: 'Error message that appears when identity input is empty',
  },
  'activate.account.identity.less.chars.error': {
    id: 'activate.account.identity.less.chars.error',
    defaultMessage: 'Username or email must have at least 2 characters.',
    description: 'Validation message that appears when identity input is less than 2 characters',
  },
  'activate.account.username.only.email.not.allowed.error': {
    id: 'activate.account.username.only.email.not.allowed.error',
    defaultMessage: 'Enter a valid username',
    description: 'Error message shown when an email address is entered in username-only activation mode',
  },
  'activate.account.page.invalid.email.message': {
    id: 'activate.account.page.invalid.email.message',
    defaultMessage: 'Enter a valid email address',
    description: 'Invalid email address message for input field.',
  },
  'activate.account.page.button.text': {
    id: 'activate.account.page.button.text',
    defaultMessage: 'Get Activation Link',
    description: 'Text for the submit button.',
  },
  'activate.account.page.username.info.text': {
    id: 'activate.account.page.username.info.text',
    defaultMessage:
      'Enter your {label}.',
    description: 'informing users to enter username info text',
  },
  'activate.account.page.verification.success.title': {
    id: 'activate.account.page.verification.success.title',
    defaultMessage:
      'Verification in process.',
    description: 'verification success page title',
  },
  'activate.account.page.verification.success.page.heading': {
    id: 'activate.account.page.verification.success.page.heading',
    defaultMessage:
      'VerificationSuccessPage',
    description: 'verification success page heading',
  },
  'activate.account.page.verification.success.description.one': {
    id: 'activate.account.page.verification.success.description.one',
    defaultMessage:
      'If this {fieldLabel} is registered, you should receive an email shortly to verify your ownership of this account.',
    description: 'verification success page first desciption',
  },
  'activate.account.page.verification.success.description.two': {
    id: 'activate.account.page.verification.success.description.two',
    defaultMessage:
      "If you don't receive the email within the next 15 minutes, please double check that you entered the correct {fieldLabel} and check your spam folder.",
    description: 'verification success page second desciption',
  },
  'activate.account.not.found.message': {
    id: 'activate.account.not.found.message',
    defaultMessage: "User {email} doesn't exist.",
    description: 'Error message when the entered user is not found in the organisation',
  },
  'activate.account.not.found.field.error': {
    id: 'activate.account.not.found.field.error',
    defaultMessage: 'No account found with this {fieldLabel}.',
    description: 'Inline field error when the entered user is not found in the organisation',
  },
  'activate.account.form.text': {
    id: 'activate.account.form.text',
    defaultMessage: 'If that account exists, a secure activation link will be sent to your registered email address.',
    description: 'Default text displayed on the activation form',
  },
});

export default messages;
